import { render } from "./RetailerWebsiteOrders.vue?vue&type=template&id=5d9e0496"
import script from "./RetailerWebsiteOrders.vue?vue&type=script&lang=js"
export * from "./RetailerWebsiteOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__